module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_dog_EN.0274ace9.png";